import React, { Component }    from 'react';
import RenderHeader            from '../../../container/renderHeader';
import validate                from '../../../service/validate_login'
import { connect }             from 'react-redux';
import { Field, reduxForm}     from 'redux-form';
import Dropzone                from 'react-dropzone';
import { Modal }               from 'react-bootstrap';
import Cropper                 from 'react-cropper';
import renderField             from '../../../container/renderField';
import { SetError,
         SetUploadFotoPerfil,
         SetEditarSenhaUser }  from '../../../actions/authenticActions';

import 'cropperjs/dist/cropper.css';

const src = '';

function converteDataUri(url){

        var binary = atob(url.split(",")[1]);
        var arr = [];
        for (var i = 0; i < binary.length; i++) {
            arr.push(binary.charCodeAt(i));
            
        }
        var objBlob = new Blob([new Uint8Array(arr)],{type:"image/jpeg"});
        return new File([objBlob],"randomname.jpeg");
}

class perfil extends Component {


    constructor(props){
        super(props);
        this.state = {
                      src, 
                      cropResult    : null,
                      disableUpload : true,
                      showModal     : false,
                      load          : false,
                      foto          : this.props.session.foto
                     }
        this.cropImage       = this.cropImage.bind(this);
        this.onChange        = this.onChange.bind(this);
        this.useDefaultImage = this.useDefaultImage.bind(this);
    }

    onDrop(e){
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.setState({ src: reader.result });
        };
        reader.readAsDataURL(files[0]);
    }

    close(){
      this.setState({showModal: false});
    }
        
    open(){
      this.setState({showModal: true});
    }
    
    onChange(e) {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.setState({ src: reader.result,load:true });
        };
        reader.readAsDataURL(files[0]);
    }

    cropImage() {

        // var file = dataURItoBlob(this.cropper.getCroppedCanvas().toDataURL(), 'image/png');

        // console.log(file);
        // const dataURL = this.cropper.getCroppedCanvas().toDataURL("image");
        // var item_image = dataURL.replace(/^data:image\/(png|jpg);base64,/, "") ;
        
        var file = converteDataUri(this.cropper.getCroppedCanvas().toDataURL());
     
         this.props.SetUploadFotoPerfil(file,this.props.session.id).then(
        (response) =>{  
            this.setState({ showModal :false,load:false });
         }).catch(
           (error) =>{
            this.props.SetError(500);
        }); 

        // if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
        //     return;
        // }

        // const imgRecortada = <div className="panel panel-default">
        //                         <div className="panel-body">
        //                            <img style={{ width: '100%' }} src={this.cropper.getCroppedCanvas().toDataURL()} alt="cropped image" />
        //                         </div>
        //                     </div>

        // this.setState({
        //     cropResult: imgRecortada,
        // });
    }
    
    useDefaultImage() {
      this.setState({ src,cropResult:null,load:false });
    }

    handleSubmit(e){
      
         this.props.SetEditarSenhaUser(e.use_senha,this.props.session.id).then((response) =>{
            alert("Ação realizada com sucesso!");
        }).catch((error) =>{
           this.props.SetError(500);
        });

   }
    render() {
        const {handleSubmit} = this.props;
        const but = {'width':'100%'}
        const but2 = {'width':'57%'}
        return (

             <div className="hud-middle-center active">
             
             <RenderHeader titulo="Perfil"/>
                <main className="hud-middle-center-content">
                <div className="communication" style={{'overflow': 'scroll'}}>
                            <div className="panel-body communication-new-input">
                                <div className="foto_perfil" >
                                     <img alt="Foto" className="img-circle img-responsive" src={this.props.session.foto}/>
                                    <p className="action" style={but} onClick={this.open.bind(this)}>Alterar imagem</p> 
                                </div>
                                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                                    <div className="form-group">
                                        <label>Nome</label>
                                        <input type="text" disabled className="form-control form-group-hud" name="use_nome" value={this.props.session.nome}/>
                                    </div>
                                    <div className="form-group">
                                        <label>Login (RA)</label>
                                        <input type="text" disabled className="form-control form-group-hud" name="use_ra" value={this.props.session.login}/>
                                    </div>
                                    <div className="form-group">
                                        <label>Email</label>
                                        <input type="text" disabled className="form-control form-group-hud" name="use_email" value={this.props.session.email}/>
                                    </div>
                                    <Field name="use_senha" type="password" className="form-control form-group-hud" label="Editar senha" component={renderField}/>
                                    <button type="submit" className="action pull-right">Editar</button>
                                </form>
                            </div>
                            <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Selecionar foto do perfil</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="panel panel-azul-claro">
                                        <div className="panel-body select-foto-ico">
                                            {
                                                !this.state.load ? 
                                                   <div>
                                                     <span className="glyphicon glyphicon-picture"></span>
                                                     <Dropzone
                                                        className="btn btn-default" 
                                                        multiple={false} accept="image/png,image/jpeg" 
                                                        onChange={this.onChange}>
                                                        <div className="text-center">Selecionar uma foto</div>
                                                     </Dropzone>
                                                    </div>
                                                     : 
                                                    <div>
                                                        <div className="conteudo-cropp">
                                                            <Cropper
                                                                style={{ height: 400, width: '418px' }}
                                                                aspectRatio={16 / 16}
                                                                guides={false}
                                                                src={this.state.src}
                                                                ref={cropper => { this.cropper = cropper; }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className="" style={{ width: '100%', float: 'left' }}>
                                                                <div className="row">
                                                                    <div className="col-md-8"><button onClick={this.cropImage} style={but2} className="action">Selecionar foto</button></div>
                                                                    <div className="col-md-4"><button onClick={this.useDefaultImage} className="action"> Limpar</button></div>
                                                                </div>
                                                            { this.state.cropResult }
                                                            </div>
                                                        </div>
                                                    </div>
                                            }                                           
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </div>                     
                </main>
            </div>  
            
           
        );
    }
}

function mapStateToProps(state){
    return { session : state.auth.session }
  }
  
  export default reduxForm({
      form                     : 'tarefa_form',
      destroyOnUnmount         : true,
      forceUnregisterOnUnmount : true,
     // onSubmitSuccess          : afterSubmit,
      validate
    })(connect(mapStateToProps, {
      SetUploadFotoPerfil,SetEditarSenhaUser,SetError
                                 })(perfil));



// WEBPACK FOOTER //
// ./src/components/aluno/perfil/perfil.js